import {useQuery} from '@apollo/client';
import { GET_LINKS } from '../../../Content/Queries/link';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const UseChooseCategories = (lang,selectedCategories,FillFormSelectedItemsWithObj,useDeletedAttribute) => {

    const {t} = useTranslation();
    const [content,SetContent] = useState(null);

    const {data,loading,error} = useQuery(GET_LINKS,{
        variables:{
            lang,
            isEshopCategory: 1
        },
        fetchPolicy:"network-only",
        skip:(lang == "" ? true : false)
    })

    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllLinks);
            SetContent(contentData);
        }

    },[data,selectedCategories])

    var headerData = [
        {
            value: t("CategoryName"),
            className:"flex-1"
        }
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        value:val.name,
                        className:"flex-1"
                    }
                ],
            }

            cData.selected = false;
            if(selectedCategories && selectedCategories.length > 0)
            {
                for(let v of selectedCategories)
                {
                    if((v.deleted == undefined || v.deleted == false) && val.linkID == v.linkID)
                        cData.selected = true;
                }
            }

            cData.rowName  = val.name;
            cData.rowID    = val.linkID;
            cData.parentID = val.parentID;

            if(val.subLink)
                cData.subData = GetContentData(val.subLink);

            contentData.push(cData)
        }
        return contentData;
    }

    const SelectRow = (e,data) => {

        var checked = e.target.checked;
        SelectLinkID(content,data.rowID,checked,true,[]);    
    }

    const SelectLinkID = (list,rowID,checked,firstCall,rowsToSelect) => {

        for(let i = 0; i < list.length; i++)
        {
            if(firstCall)
                rowsToSelect = new Array();

            if(rowID == list[i].rowID || rowID === "all")
            {                
                if(checked)
                {
                    for(let j = 0; j < rowsToSelect.length; j++)
                    {
                        if(!rowsToSelect[j].selected)
                            FillFormSelectedItemsWithObj("selectedCategories","linkID",{
                                name: rowsToSelect[j].rowName,
                                linkID: rowsToSelect[j].rowID,
                                isMain:0,
                                add:true,
                                deleted:false
                            },useDeletedAttribute);
                    }
                }

                FillFormSelectedItemsWithObj("selectedCategories","linkID",{
                    name: list[i].rowName,
                    linkID: rowID,
                    isMain:0,
                    add:true,
                    deleted:false
                },useDeletedAttribute);

                break;

            }

            if(list[i].subData)
            {
                rowsToSelect.push({
                    rowName: list[i].rowName,
                    rowID: list[i].rowID,
                    selected: list[i].selected
                })
                
                SelectLinkID(list[i].subData,rowID,checked,false,rowsToSelect);
        
            }
        }
    }

    return{
        content,
        headerData,
        loading,
        error,
        SelectRow
    }

}

export default UseChooseCategories;